import { Instance } from 'mobx-state-tree'
import { LearningModuleModelBase } from './LearningModuleModel.base'

/* The TypeScript type of an instance of LearningModuleModel */
export interface LearningModuleModelType extends Instance<typeof LearningModuleModel.Type> {}

/* A graphql query fragment builders for LearningModuleModel */
export {
  selectFromLearningModule,
  learningModuleModelPrimitives,
  LearningModuleModelSelector
} from './LearningModuleModel.base'

/**
 * LearningModuleModel
 */
export const LearningModuleModel = LearningModuleModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
